import {LiveRoomReportDTO, QuestionAnswersCount, QuestionReport} from '../../incase-domain/analytics';
import {
    CREATE_SLIDES_ANALYTICS,
    FETCH_QUESTION_ANSWERS_COUNT,
    FETCH_QUESTION_REPORT,
    FETCH_SLIDES_ANALYTICS,
    ICreateSlidesAnalyticsActionType,
    IFetchQuestionAnswersCountActionType,
    IFetchQuestionReportActionType,
    IFetchSlidesAnalyticsActionType,
    IUpdateAnalyticsDataActionType,
    IUpdateLiveRoomReportActionType,
    IUpdateQuestionAnswersCountActionType,
    IUpdateQuestionReportActionType,
    IUpdateSlidesAnalyticsActionType,
    IUpdateSlidesAnalyticsTimeActionType,
    UPDATE_ANALYTICS_DATA,
    UPDATE_LIVE_ROOM_REPORT,
    UPDATE_QUESTION_ANSWERS_COUNT,
    UPDATE_QUESTION_REPORT,
    UPDATE_SLIDES_ANALYTICS,
    UPDATE_SLIDES_ANALYTICS_UPDATE_TIME,
} from './types/analytics.actions.types';
import {ISlidesAnalytics} from '../../incase-domain/proptypes/slidesAnalytics';

export const createSlidesAnalyticsAction = (runFileId: string, presentationId: string): ICreateSlidesAnalyticsActionType => ({
    type: CREATE_SLIDES_ANALYTICS,
    payload: {runFileId, presentationId},
});

export const fetchQuestionReportAction = (elementId: string, roomRunfileId?: string): IFetchQuestionReportActionType => ({
    type: FETCH_QUESTION_REPORT,
    elementId,
    roomRunfileId,
});

export const updateQuestionReportAction = (questionReport: QuestionReport): IUpdateQuestionReportActionType => ({
    type: UPDATE_QUESTION_REPORT,
    questionReport,
});

export const fetchSlidesAnalyticsAction = (runfileId: string): IFetchSlidesAnalyticsActionType => ({
    type: FETCH_SLIDES_ANALYTICS,
    runfileId,
});

export const updateSlidesAnalyticsAction = (slidesAnalytics: ISlidesAnalytics): IUpdateSlidesAnalyticsActionType => ({
    type: UPDATE_SLIDES_ANALYTICS,
    slidesAnalytics,
});

export const updateSlidesAnalyticsUpdateTimeAction = (time: number): IUpdateSlidesAnalyticsTimeActionType => ({
    type: UPDATE_SLIDES_ANALYTICS_UPDATE_TIME,
    time,
});

export const updateAnalyticsDataAction = (analyticsData: []): IUpdateAnalyticsDataActionType => ({
    type: UPDATE_ANALYTICS_DATA,
    analyticsData,
});

export const fetchQuestionAnswersCountAction = (
    elementId: string,
    roomId: string,
    roomRunFileId: string
): IFetchQuestionAnswersCountActionType => ({
    type: FETCH_QUESTION_ANSWERS_COUNT,
    elementId,
    roomId,
    roomRunFileId,
});

export const updateQuestionAnswersCountAction = (questionAnswersCount: QuestionAnswersCount): IUpdateQuestionAnswersCountActionType => ({
    type: UPDATE_QUESTION_ANSWERS_COUNT,
    questionAnswersCount,
});

export const updateLiveRoomReportAction = (liveRoomReport: LiveRoomReportDTO): IUpdateLiveRoomReportActionType => ({
    type: UPDATE_LIVE_ROOM_REPORT,
    liveRoomReport,
});
